import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ChangeLog,
  GeneralLedgerTransaction,
  Pagination,
  Response,
} from '@ui/src';
import { Comment, CustomerType } from '../../types';
import { customersComponentApi } from '../services/customers';

export interface ProblemGeneralTransactionState {
  isLoading: boolean;
  transaction?: GeneralLedgerTransaction;
  transactionId?: string;
  requestInProgress?: boolean;
  commentSendSuccess?: boolean;
  comment?: Comment;
  customerType?: CustomerType;
  transactionChangeLogs?: ChangeLog[];
  transactionChangeLogsPagination?: Pagination;
}

const initialState: ProblemGeneralTransactionState = {
  isLoading: false,
  transaction: undefined,
  transactionId: undefined,
};

export const problemGeneralTransactionSlice = createSlice({
  name: 'problemGeneralTransaction',
  initialState,
  reducers: {
    clearTransactionState: (state) => {
      state.transaction = undefined;
      state.transactionId = undefined;
      state.commentSendSuccess = false;
      state.customerType = undefined;
      state.transactionChangeLogs = undefined;
      state.transactionChangeLogsPagination = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        customersComponentApi.endpoints.getCustomerGeneralLedgerTransaction
          .matchFulfilled,
        (state, action: PayloadAction<{ data: GeneralLedgerTransaction }>) => {
          state.transaction = {
            ...action.payload.data,
          };
        },
      )
      .addMatcher(
        customersComponentApi.endpoints.getCustomerStatementChangeLogs
          .matchFulfilled,
        (
          state,
          action: PayloadAction<Response<ChangeLog>> & {
            meta: { arg: { originalArgs: string } };
          },
        ) => {
          if (state.transaction) {
            if (!action.meta.arg.originalArgs.includes('cursor')) {
              state.transactionChangeLogs = action.payload.data?.edges?.map(
                (item) => item.node,
              );
            } else {
              const nextChangeLogs = ([] as ChangeLog[]).concat(
                state.transactionChangeLogs as ChangeLog[],
              );

              action.payload.data.edges?.forEach((item) => {
                nextChangeLogs.push(item.node);
              });

              state.transactionChangeLogs = nextChangeLogs;
            }

            state.transactionChangeLogsPagination =
              action.payload.data?.pageInfo;
          }
        },
      );
  },
});

export const { clearTransactionState } = problemGeneralTransactionSlice.actions;

export default problemGeneralTransactionSlice.reducer;
